import { useEntryContext } from '../context/EntryContext';

interface Props { fieldKey?: string }

export function EntryCoverImageBlock({ fieldKey = 'imageUrl' }: Props) {
  const { entry } = useEntryContext();
  const src = entry.dataJson?.[fieldKey] as string | undefined;
  if (!src) return null;
  return (
    <div className="w-full overflow-hidden rounded-xl">
      <img src={src} alt={entry.title} className="w-full object-cover" loading="lazy" />
    </div>
  );
}
